import { GroupSearchFieldNamesType, GroupSearchValue, DEFAULT_FIELD_NAMES, } from "./interface";

/**
 * 过滤对象空值
 * @param groupValue 值
 * @param fieldNames 字段映射
 */
export function filterEmptyGroupSearchValue(groupValue?: GroupSearchValue, fieldNames?: GroupSearchFieldNamesType): GroupSearchValue | undefined {
  if (!groupValue) return undefined;
  const newGroupValue: GroupSearchValue = {};
  const searchTypeName = fieldNames?.searchType || DEFAULT_FIELD_NAMES.searchType;
  const matchConditionName = fieldNames?.matchCondition || DEFAULT_FIELD_NAMES.matchCondition;
  const matchValueName = fieldNames?.matchValue || DEFAULT_FIELD_NAMES.matchValue;
  const matchValue = groupValue[matchValueName];
  if (groupValue[searchTypeName]) newGroupValue[searchTypeName] = groupValue[searchTypeName];
  if (groupValue[matchConditionName]) newGroupValue[matchConditionName] = groupValue[matchConditionName];
  if (Array.isArray(matchValue) && matchValue.length) {
    newGroupValue[matchValueName] = matchValue;
  }
  const keys = Object.keys(newGroupValue);
  return (Array.isArray(keys) && keys.length) ? newGroupValue : undefined;
}